<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
     
    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card  (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
               Firmalar
              </ng-container>
              <ng-container mCardBody>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Firma Ara (aramak için firma adı yazıp enter tuşuna basınız)</label>
                      <input type="text" [(ngModel)]="search" class="form-control" (change)="ara()">
                    </div>
                  </div>

                 
                </div>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Adı</th>
                        
                       
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let firma of firmalar">
                        
                          <td>{{firma.madde}} </td>
                        
                          
                          <td>
                          
                         <button routerLink="/firmamustahzar/{{firma.id}}" class="btn btn-primary">   <i class="fa fa-edit" ></i> Müstahzarlara Git</button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>
                            <button class="btn btn-default" (click)="prev()"><<</button>
                            <button class="btn">{{page}}</button>
                            <button class="btn btn-default" (click)="next()">>></button>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
               
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
